import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { SiteProvider } from "@/context/SiteContext";
import Login from "@/pages/Login";
import Academy from "@/pages/Academy";
import HQ from "@/pages/HQ";
import Founders from "@/pages/Founders";
import Home from "@/pages/Home";
import AcademyOffer from "@/pages/AcademyOffer";
import Guide from "@/pages/Guide";
import Calculator from "@/pages/Calculator";
import Choose from "@/pages/Choose";
import DepositSuccess from "@/pages/DepositSuccess";
import Events from "@/pages/Events";
import LeadCapture from "@/pages/LeadCapture";
import { Apply, Learn, Lemonading, LessonPage, Stories, StoryPage } from "@/pages/Media";
import { Buy, PaymentCancel, PaymentSuccess } from "@/pages/Payment";

/** Public marketing site — the same routes whether or not someone is logged in. */
const publicRoutes = [
  ["/", <Choose />],
  ["/operators", <Home />],
  ["/events", <Events />],
  ["/stories", <Stories />],
  ["/stories/:slug", <StoryPage />],
  ["/lemonading", <Lemonading />],
  ["/learn", <Learn />],
  ["/learn/:slug", <LessonPage />],
  ["/academy", <AcademyOffer />],
  ["/our-story", <Founders />],
  ["/founders", <Navigate to="/our-story" replace />],
  ["/apply", <Apply />],
  ["/catering", <Navigate to="/events" replace />],
  ["/book", <Navigate to="/events" replace />],
  ["/guide", <Guide />],
  ["/calculator", <Calculator />],
  ["/start", <Navigate to="/academy" replace />],
  ["/waitlist/:productKey", <LeadCapture />],
  ["/payment/success", <PaymentSuccess />],
  ["/payment/cancel", <PaymentCancel />],
  ["/deposit/success", <DepositSuccess />],
];

const Shell = () => {
  const { user, loading } = useAuth();
  if (loading)
    return <div className="p-10 mono text-sm text-muted-foreground">Firing up the griddle…</div>;

  const marketing = publicRoutes.map(([path, element]) => (
    <Route key={path} path={path} element={element} />
  ));

  if (!user)
    return (
      <Routes>
        {marketing}
        <Route path="*" element={<Login />} />
      </Routes>
    );

  return (
    <DataProvider>
      <Routes>
        {marketing}
        <Route path="/academy-dashboard" element={<Academy />} />
        <Route path="/login" element={<Navigate to="/academy-dashboard" replace />} />
        <Route path="/hq" element={<HQ />} />
        <Route path="/buy/:lookupKey" element={<Buy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </DataProvider>
  );
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Shell />
            <Toaster theme="dark" position="top-right" />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
